module.exports = __webpack_public_path__ + "static/img/share-wb_light.2db60b07.png";